// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"24":"dee6e7fa","41":"290b4757","54":"454656eb","639":"0525201b"}[chunkId] + ".chunk.css";
};